// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","455":"cc930014","488":"7213179a","977":"c3d99690"}[chunkId] + ".chunk.js";
};